import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, useLocation } from 'react-router-dom';
import CodingProjects from './pages/CodingProjects';
import ArtProjects from './pages/ArtProjects';
import DesignProjects from './pages/DesignProjects';
import Animation from './pages/Animation';
import HomePage from './pages/HomePage';
import './App.css';

function Header() {
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  
  const [isNavOpen, setIsNavOpen] = useState(false); // State for toggling the menu

  if (isHomePage) return null; // Hide header on the homepage

  const toggleNav = () => setIsNavOpen(prev => !prev); // Toggle the navigation menu

  return (
    <header className="app-header">
      <Link to="/" className="home-link">
        will hardison
      </Link>
      <button className="menu-toggle" onClick={toggleNav}>
        ☰
      </button>
      <nav className={`projects-nav ${isNavOpen ? "open" : ""}`}>
        <Link className="projects-nav-link" to="/code">code</Link>
        <Link className="projects-nav-link" to="/art">art</Link>
        <Link className="projects-nav-link" to="/design">design</Link>
        <Link className="projects-nav-link" to="/animation">animation</Link>
      </nav>
    </header>
  );
}

function App() {
  return (
    <Router>
      <div className="app-container">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/code" element={<CodingProjects />} />
          <Route path="/art" element={<ArtProjects />} />
          <Route path="/design" element={<DesignProjects />} />
          <Route path="/animation" element={<Animation />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
